// src/pages/MyEntries.jsx
import React, { useEffect, useContext } from 'react';
import { ContractContext } from '../contexts/ContractContext';
import PoolCard from '../components/PoolCard';

const MyEntries = () => {
  const { userEntries, loadUserEntries, isLoading, error } = useContext(ContractContext);

  useEffect(() => {
    loadUserEntries();
  }, [loadUserEntries]);

  if (isLoading) {
    return (
      <div>
        <h2>Your Entries</h2>
        <div className="pool-grid">
          <div className="card">
            <h3>Loading your entries...</h3>
            <div className="loading"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h2>Your Entries</h2>
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div>
      <h2>Your Entries</h2>
      {userEntries.length === 0 ? (
        <div className="pool-grid">
          <div className="card">
            <p>You haven't entered any pools yet.</p>
          </div>
        </div>
      ) : (
        <div className="pool-grid">
          {userEntries.map(pool => (
            <PoolCard key={pool.id} pool={pool} type="user-entry" />
          ))}
        </div>
      )}
    </div>
  );
};

export default MyEntries;